import { render, staticRenderFns } from "./assign-customers.vue?vue&type=template&id=a45d619a&"
import script from "./assign-customers.vue?vue&type=script&lang=ts&"
export * from "./assign-customers.vue?vue&type=script&lang=ts&"
import style0 from "./assign-customers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports